import { User } from '../main'
import { useNavigate } from 'react-router-dom'

interface HomePageProps {
  user?: User
}

export function HomePage({ user }: HomePageProps) {
  const navigate = useNavigate()
  
  // Calculate days since registration (mock for now)
  const registrationDate = new Date('2025-01-07') // Today's date as placeholder
  const daysSinceRegistration = Math.floor((Date.now() - registrationDate.getTime()) / (1000 * 60 * 60 * 24))

  return (
    <div className="page">
      <div className="container">
        <div className="hero">
          <h1>Welcome to the Universe{user ? `, ${user.username}` : ''}!</h1>
          <p className="hero-subtitle">
            You're now part of the SWGRealms early access program. The universe awaits, 
            but first we need to finish building the hyperdrive...
          </p>
        </div>

        <div className="dashboard-grid">
          <div className="swg-window">
            <div className="swg-window-header">
              <h3>Your Citizen Status</h3>
            </div>
            <div className="swg-window-content">
              <div className="status-indicator status-online mb-md">
                <span>●</span> Early Access Colonist
              </div>
              
              <div style={{fontSize: '0.9rem'}}>
                <div className="mb-sm" style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span>Registry Status:</span>
                  <span style={{fontWeight: 'bold', color: 'var(--swg-accent)'}}>Active</span>
                </div>
                <div className="mb-sm" style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span>Days Since Joining:</span>
                  <span style={{fontWeight: 'bold'}}>{daysSinceRegistration}</span>
                </div>
                <div className="mb-sm" style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span>Legacy Veteran:</span>
                  <span style={{fontWeight: 'bold', color: user?.verified ? 'var(--swg-accent)' : 'var(--swg-text-secondary)'}}>
                    {user?.verified ? 'Verified' : 'Pending'}
                  </span>
                </div>
                <div className="mb-sm" style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span>Galaxies Available:</span>
                  <span style={{fontWeight: 'bold', color: 'var(--swg-text-secondary)'}}>Coming Soon™</span>
                </div>
              </div>

              <div className="progress-bar mt-md">
                <div className="progress-fill action" style={{width: '25%'}}></div>
                <div className="progress-text">25% Complete</div>
              </div>
            </div>
          </div>

          <div className="swg-window">
            <div className="swg-window-header">
              <h3>What's Next?</h3>
            </div>
            <div className="swg-window-content">
              <p className="mb-md">While our engineers work around the clock (and around Imperial red tape), here's what you can do:</p>
              
              <div style={{fontSize: '0.9rem', color: 'var(--swg-text-secondary)'}}>
                <div className="mb-sm">✅ <strong>Set up your profile</strong> - Make it yours</div>
                <div className="mb-sm">🔄 <strong>Check back regularly</strong> - New features weekly</div>
                <div className="mb-sm">💬 <strong>Join our Discord</strong> - Connect with other rebels</div>
                <div className="mb-sm">📧 <strong>Watch your email</strong> - Launch notifications coming</div>
              </div>

              <div className="mt-md">
                <button 
                  className="btn btn-primary" 
                  style={{width: '100%'}}
                  onClick={() => navigate('/profile')}
                >
                  Complete Your Profile
                </button>
              </div>
            </div>
          </div>

          <div className="swg-window">
            <div className="swg-window-header">
              <h3>Development Progress</h3>
            </div>
            <div className="swg-window-content">
              <p className="mb-md">Current focus areas:</p>
              
              <div className="mb-sm">
                <small>Authentication System</small>
                <div className="progress-bar">
                  <div className="progress-fill action" style={{width: '100%'}}></div>
                  <div className="progress-text">Complete</div>
                </div>
              </div>
              
              <div className="mb-sm">
                <small>User Profiles & Settings</small>
                <div className="progress-bar">
                  <div className="progress-fill mind" style={{width: '60%'}}></div>
                  <div className="progress-text">In Progress</div>
                </div>
              </div>
              
              <div className="mb-sm">
                <small>Galaxy Browser</small>
                <div className="progress-bar">
                  <div className="progress-fill health" style={{width: '30%'}}></div>
                  <div className="progress-text">Design Phase</div>
                </div>
              </div>
              
              <div className="mb-sm">
                <small>Game Client Integration</small>
                <div className="progress-bar">
                  <div className="progress-fill health" style={{width: '15%'}}></div>
                  <div className="progress-text">Planning</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Imperial Notice */}
        <div className="mt-xl">
          <div className="swg-window">
            <div className="swg-window-header">
              <h3>Imperial Development Notice</h3>
            </div>
            <div className="swg-window-content">
              <div className="status-indicator status-warning mb-md">
                <span>●</span> Early Access Program Active
              </div>
              <p style={{fontSize: '0.9rem', color: 'var(--swg-text-secondary)'}}>
                You're experiencing SWGRealms during active development. Features will be added regularly, 
                and your feedback helps shape the platform. The Empire appreciates your patience as we 
                navigate the complex bureaucracy of galactic infrastructure deployment.
              </p>
              <p style={{fontSize: '0.8rem', fontStyle: 'italic', marginTop: 'var(--swg-spacing-md)'}}>
                "Remember: The best rebellions are built one commit at a time."
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
